import { AxiosResponse } from 'axios';
import { BaseService } from './_base';

interface SubscriptionDetails {
    plan_id: string;
    plan: string;
    next_renewal_date: string;
    next_interval_months: number;
    next_rate_per_employee: number;
    next_plan_id: string;
    next_plan_label: string;
    employees: number;
    stripe: string;
    has_payment_method: boolean;
    is_trial: boolean;
    trial_until: string;
}

class BillingService extends BaseService<{}> {
    constructor() {
        super("/api/v2/billing/billing/");
        this.cacheTimeout = 5;
    }

    subscriptionDetails(): Promise<AxiosResponse<SubscriptionDetails>> {
        return this._get('subscription-details/');
    }


}

const billingService = new BillingService();

export { billingService, };
export type { BillingService, SubscriptionDetails };

export default billingService;

